/* ------------------------------------*\
    VARIABLE DECLARATION
\*------------------------------------*/

// eslint-disable-next-line no-unused-vars
var is_mobile = false;
var prev_size = "";

$(window).on('load', () => {
    /*------------------------------------*\
        CALL TO FUNCTIONS
    \*------------------------------------*/
    console.log(
        '<!-- ----------------------------------------------------- -->\n' +
        '<!-- Code by David Penuela, http://davidpenuela.com (2020) -->\n' +
        '<!-- ----------------------------------------------------- -->');
    setupCommon();

});

/*------------------------------------*\
GENERAL
\*------------------------------------*/
function setupCommon() {

    if(deviceDetector.device == 'desktop'){
        // You're on a desktop.
        // console.log('desktop');
        setupGSAPFooter();
    }else{
        setupMenuNavigation_mobile();
        if(deviceDetector.device == 'tablet'){
            // You're on a tablet.
            // console.log('tablet');
        }else{
            // console.log('phone');
        }
        // You're on a phone.
    }
    prev_size = is_mobile;

    setupNewsletterPopup();
    checkPopupBox();
    setupAjaxAddToCart();
}

function setupGSAPFooter(){
    var tl = gsap.timeline();
    // tl.staggerTo(wrf_title, 1, {opacity: 1, stagger: 0.2});
    // tl.to('#svg_00_svg_logo_title',
    //  {rotate: 360,  duration: 10, ease: Linear.easeNone});
    // tl.to('#svg_00_svg_logo_title',20,{rotation:360,transformOrigin:"50% 50%",ease:Linear.easeNone}, "<");
    var tl2 = gsap.timeline({repeat:-1});
    tl2.to('#svg_01_logo_title',{rotation:-360,transformOrigin:"50% 50%",ease:Linear.easeNone, duration: 30});
}
function setupMenuNavigation_mobile(){
    const $menu_toggle = $('.menu_toggle_mobile');
    const $nav_container = $('.nav-main-mobile');

    $menu_toggle.on('click', function(){
        $nav_container.toggleClass('active');
    });
}

/*------------------------------------*\
NEWSLETTER FORM
\*------------------------------------*/
function setupEmailValidation(){
    const $input_field = $('#mce-EMAIL');
    const $mc_container = $('.newsletter-form-section');
    $input_field.on('input',function(){
        if($(this).val().indexOf("@")>0){
            $mc_container.addClass('at-validated');
        }else{
            $mc_container.removeClass('at-validated');
        }

    });

}

function setupNewsletterPopup(){
    setupEmailValidation();
    setupMCAjax();
    const $submit = $('.submit-icon');

    $('#newsletter_popup_toggle, .mailchimp-container-inside-form-close-popup').on('click',function(){
        $('.mailchimp-container').toggleClass('active');
        if($('.nav-main').hasClass('active')){
            $('.nav-main').removeClass('active')
        }
    });

    $submit.on('click',function(){
        if($('#mc_terms_checkbox').is(':checked')){
            $( "#mc-embedded-subscribe-form" ).submit();
        }else{
            $('.mc_terms_checkmark').addClass('required');
        }
    });
}

function callbackFunction(resp) {
    if (resp.result === 'success') {
        // console.log('success');
        $('.newsletter-form-section').addClass('form-submitted');
    }else{
        //
    }
}

function setupMCAjax(){
    $('#mc-embedded-subscribe-form').ajaxChimp({
        callback: callbackFunction
    });

}

function checkPopupBox(){
    const popup_cookie = Cookies.get('newsletter_popup_closed');
    if( popup_cookie != 'set'){
        Cookies.set('newsletter_popup_closed', 'set', { expires: 5 });
        if(deviceDetector.device != 'desktop'){
            setTimeout(function(){
                $('.mailchimp-container').addClass('active');
            },20000);
        }else{
            setTimeout(function(){
                $('.mailchimp-container').addClass('active');
            },20000);
        }
    }
}


function setupAjaxAddToCart(){
    var $cta_add_to_cart = $('.cta_button_add_to_cart');
    if($cta_add_to_cart.length >0 ){
        $cta_add_to_cart.on('click',function(e){
            e.preventDefault();
            e.stopPropagation();
            var product_id = $(this).attr('data-value');
            // console.log('--------------');
            // console.log(product_id);
            // console.log(this);
            // console.log('--------------');
            var quantity = 1;
            // return 0;
            // console.log(woocommerce_params.ajax_url);
            // console.log(woocommerce_params);
            if (quantity > 0) {
                jQuery.ajax ({
                    url: woocommerce_params.ajax_url,
                    type:'POST',
                    data:'action=woocommerce_ajax_add_to_cart&product_id=' + product_id + '&quantity=' + quantity + '&mode=add_item',
                    success:function(data) {
                        // console.log("SUCCESS!");
                        // console.log(data);
                        $(document.body).trigger("update_checkout");
                        // update counter
                        var $counter = $( '#mini-cart-count' );
                        var currentQuantity = parseInt( $counter.html(), 10 );
                        var newQuantity = currentQuantity + 1;
                        $counter.text( newQuantity );
                    },
                    error:function(data){
                        // console.log(data);
                    }
                });

                return false;

            }

        });
    }

    // $('.single_add_to_cart_button').each(function(index){
    //     $(this).on('click', function(e){
    //         e.preventDefault();

    //         var product_id = $(this).attr('data-value');
    //         console.log('--------------');
    //         console.log(product_id);
    //         console.log(this);
    //         console.log('--------------');
    //         var quantity = 1;
    //         // return 0;
    //         // console.log(woocommerce_params.ajax_url);
    //         // console.log(woocommerce_params);
    //         if (quantity > 0) {
    //             e.preventDefault();
    //             jQuery.ajax ({
    //                 url: woocommerce_params.ajax_url,
    //                 type:'POST',
    //                 data:'action=mode_theme_update_mini_cart&product_id=' + product_id + '&quantity=' + quantity + '&mode=add_item',
    //                 success:function(data) {
    //                     // console.log("SUCCESS!");
    //                     // console.log(data);
    //                     $(document.body).trigger("update_checkout");
    //                     // update counter
    //                     var $counter = $( '#mini-cart-count' );
    //                     var currentQuantity = parseInt( $counter.html(), 10 );
    //                     var newQuantity = currentQuantity + 1;
    //                     $counter.text( newQuantity );
    //                 },
    //                 error:function(data){
    //                     console.log(data);
    //                 }
    //             });

    //             return false;

    //         }
    //     });
    // });
}

/*------------------------------------*\
PAGE CHECKERS
\*------------------------------------*/

// Extra methods
function isHome() {
    if ($("body").hasClass("home")) {
        return true;
    }
    return false;
}

function isCart() {
    if ($("body").hasClass("woocommerce-cart")) {
        return true;
    }
    return false;
}

function isAccountPage(){
    if ($("body").hasClass("woocommerce-account")) {
        return true;
    }
    return false;
}

function isArchiveBA(){
    if ($("body").hasClass("post-type-archive-wine-club-archive")) {
        return true;
    }
    return false;
}
function isSingleBA(){
    if ($("body").hasClass("single single-wine-club-archive")) {
        return true;
    }
    return false;
}

function isPageNWC(){
    if ($("body").hasClass("single-product")) {
        return true;
    }
    return false;
}

function isSingleProduct(){
    if ($("body").hasClass("single-product")) {
        return true;
    }
    return false;
}

function isProductArchive(){
    if ($("body").hasClass("post-type-archive-product")) {
        return true;
    }
    return false;
}

/*------------------------------------*\
Extra methods
\*------------------------------------*/

function isSmallScreen() {
    if ($(window).width() > 991) {
        return false;
    } else {
        return true;
    }
}

function setIsMobileBool(){
    // var windowsize = $(window).width();
    // if (windowsize < 991){
    //     is_mobile = true;
    // }
    //same as below
    is_mobile = $(window).width() < 991 ? true : false;
}
$( window ).on( 'resize', function() {
    if(is_mobile != prev_size){
        // this.location.reload();
        // location.href = location.href;
        // console.log('RELOAD');
    }
    prev_size = is_mobile;
    setIsMobileBool();

    if(showing_debug){
        $('#debug-resolution-w').html($(window).outerWidth());
        $('#debug-resolution-h').html($(window).outerHeight());
    }


} );

//https://github.com/PoeHaH/devicedetector/blob/master/devicedetector-production.js
var deviceDetector = (function (){
    /*
    if(deviceDetector.device == 'desktop')
    // You're on a desktop.
    else{
        if(deviceDetector.device == 'tablet')
            // You're on a tablet.
        else
        // You're on a phone.
    }
    */
    var ua = navigator.userAgent.toLowerCase();
    var detect = (function(s){
        if(s===undefined)s=ua;

        else ua = s.toLowerCase();
        if(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(ua)){
            return 'tablet';
        }else{
            if(/(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(ua)){
                return 'phone';
            }else {
                return 'desktop';
            }
        }

    });
    return{
        device:detect(),
        detect:detect,
        isMobile:((detect()!='desktop')?true:false),
        userAgent:ua
    };
}());

/*------------------------------------*\
jQuery Events
\*------------------------------------*/
$(window).on('scroll', function () {});

/*------------------------------------*\
GRID DISPLAY
\*------------------------------------*/
var showing_debug = false;
$( document ).on( 'keypress', function( event ) {
    // if ( event.key === 'g' || event.key === 'G' ) {
    //     $( '.grid-columns' ).toggleClass( 'active' );
    // }
    // if ( event.key === 'r' || event.key === 'R' ) {
    //     $( '.debug-resolutions' ).toggleClass( 'active' );
    //     showing_debug=!showing_debug;
    // }
} );

